Property_gallery = {
	init : function()
	{
		// Test video.
		//var temp_slide = '<li class="slide"><div class="hero"><iframe width="560" height="315" src="https://www.youtube.com/embed/dnK-KtuQ9wU?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></li>';
		//jQuery('#gallery .main .gallery-list').prepend(temp_slide);
		
		jQuery('#gallery .main .gallery-list, #gallery-non-centered .main .gallery-list').on('init', function(event, slick){
			jQuery('#gallery .main .gallery-list, #gallery-non-centered .main .gallery-list').addClass('initialised');
		});
		
		// On before slide change
		jQuery('#gallery .main .gallery-list, #gallery-non-centered .main .gallery-list').on('beforeChange', function(event, slick, currentSlide, nextSlide)
		{
			//console.log('CHANGE SLIDES ',currentSlide, nextSlide);
			//if ( currentSlide == 2 ) // assuming the video was on slide 2
			//{
			//	player.pause();
			//}
			
			//jQuery('#gallery .main .gallery-list .oc--video-player')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			jQuery('#gallery .main .gallery-list .oc--video-player.oc--youtube').each(function(){
				jQuery(this)[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			
			jQuery('#gallery .main .gallery-list .oc--video-player.oc--vimeo').each(function(){
				//jQuery(this).api("pause");
				jQuery(this)[0].contentWindow.postMessage('{"method":"pause"}', '*');
			});
		});
		
		jQuery('#gallery .main .gallery-list').slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			centerMode: true,
			centerPadding: 0,
			infinite: true,
			//asNavFor: '#gallery .thumbnails .gallery-list',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						centerPadding: 0
					}
				},
				{
					breakpoint: 768,
					settings: {
						centerPadding: '25%'
					}
				},
				{
					breakpoint: 992,
					settings: {
						centerPadding: '25%'
					}
				},
				{
					breakpoint: 1200,
					settings: {
						centerPadding: '25%'
					}
				}
			]
		});
		
		// Simple non centered gallery.
		jQuery('#gallery-non-centered .main .gallery-list').slick({
			lazyLoad: 'ondemand',
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			centerMode: false,
			centerPadding: 0,
			infinite: true,
			//asNavFor: '#gallery .thumbnails .gallery-list',
			mobileFirst: true,
			responsive: [
			]
		});
		
		jQuery('#gallery .thumbnails .gallery-list, #gallery-non-centered .thumbnails .gallery-list').slick({
			lazyLoad: 'ondemand',
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: true,
			dots: false,
			centerMode: false,
			centerPadding: 0,
			infinite: false,
			//asNavFor: '#gallery .main .gallery-list',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 6,
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 7,
						slidesToScroll: 7,
					}
				}
			]
		});
		
		jQuery('#gallery .thumbnails .gallery-list li, #gallery-non-centered .thumbnails .gallery-list li').each(function(index){
			jQuery(this).click(function(){
				jQuery('#gallery .main .gallery-list, #gallery-non-centered .main .gallery-list').slick('slickGoTo',index);
			});
		});
	}
}

OC_Property_gallery_lightbox =
{
	init : function()
	{
		jQuery('#gallery-lighthouse .action').click(function(){
			///var currentSlide = jQuery(this).slick('slickCurrentSlide');
			///console.log('GALLERY CLICK',currentSlide);
			
			var gallery = jQuery('#gallery-lighthouse').attr('data-gallery');
			var gallery_array = gallery.split(',');
			var gallery_list = new Array();
			
			
			for (var i = 0; i < gallery_array.length; i++)
			{
				var image = gallery_array[i];
				var image_url = image.replace(/'/g,'');
				var image_obj = { 'src': image_url, 'thumb': image_url };
				gallery_list.push(image_obj);
			}
			
			/*
			var image_url = 'http://www.rentalz.com.au/prop_images/FHD_images/2324IB2064862016.JPG';
			var image_obj = { 'src': image_url, 'thumb': image_url };
			gallery_list.push(image_obj);
			
			var image_url = 'http://www.rentalz.com.au/prop_images/FHD_images/2324IB2017413016.JPG';
			var image_obj = { 'src': image_url, 'thumb': image_url };
			gallery_list.push(image_obj);
			
			var image_url = 'http://www.rentalz.com.au/prop_images/FHD_images/2324IB2043290016.JPG';
			var image_obj = { 'src': image_url, 'thumb': image_url };
			gallery_list.push(image_obj);
			*/
			
			jQuery('#gallery-lighthouse').lightGallery({
				dynamic: true,
				dynamicEl: gallery_list,
				thumbnail:true/*,
				index: parseInt(currentSlide)*/
			});
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	Property_gallery.init();
	OC_Property_gallery_lightbox.init();
	
	// Object Fit Polyfill for images.
	var $images_polyfill_list = jQuery('#gallery .hero img');
	if( $images_polyfill_list.size() > 0 )
	{
		//objectFitImages( $images_polyfill_list );
	}
	
});